/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandPicsart = createReactComponent("brand-picsart", "IconBrandPicsart", [
  ["path", { d: "M12 9m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", key: "svg-0" }],
  ["path", { d: "M12 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M5 9v11a2 2 0 1 0 4 0v-4.5", key: "svg-2" }]
]);

export { IconBrandPicsart as default };
//# sourceMappingURL=IconBrandPicsart.js.map
